import { TdsButton, TdsModal, TdsModalButtons } from '@trv-tds/react';
import React, { createRef, useEffect, useState } from 'react';
import Countdown from './Countdown';
import './timeout.scss';

const LOGGED_IN = 'STAY LOGGED IN';
const BUTTON_VALUE = 'stay';

const timeoutModalRef = createRef();

const TimeoutModal = ({ time, reset }) => {
    const [activeElement, setActiveElement] = useState(null);

    useEffect(() => {
        if (time > 0) {
            setActiveElement(document.activeElement);
            timeoutModalRef.current.open();
        }
    }, [time]);

    const close = ({ detail: returnValue }) => {
        if (returnValue === BUTTON_VALUE) {
            reset();
        }
    };

    const closed = ({ detail: returnValue }) => {
        // Meets a11y focus requirement for modals
        if (activeElement && returnValue === BUTTON_VALUE) {
            activeElement.focus();
            setActiveElement(null);
        }
    };

    return (
        <>
            <TdsModal
                id="timeout-modal"
                data-testid="timeout-modal"
                size="medium"
                dialogTitle="Need More Time?"
                noDismiss="true"
                ref={timeoutModalRef}
                onTdsClose={close}
                onTdsClosed={closed}
            >
                <p className="tds-bold">Due to inactivity, you will be logged off in:</p>
                <div style={{ backgroundColor: '#dadbdb' }}>
                    <div className="tds-bold tds-mt-s">
                        <Countdown key={time} time={time} />
                    </div>
                </div>
                <div>
                    <p className={'tds-mt-s tds-mb-0'} id="timeout-modal-desc">
                        Any information you have entered will be lost, and you will be brought back
                        to the Premium Audit Registration main page.
                    </p>
                </div>
                <TdsModalButtons slot="footer">
                    {/* TODO: slot seems to cause issues with IE11 - need fix  */}
                    <div className="dialog-footer-fix">
                        <TdsButton variant="primary" data-dismiss="modal" value={BUTTON_VALUE}>
                            {LOGGED_IN}
                        </TdsButton>
                    </div>
                </TdsModalButtons>
            </TdsModal>
        </>
    );
};

export default TimeoutModal;
